import Rules from "./rules";
import {alertDialogStoreFactory, StoreFactory} from "./store/AlertDialogStoreFactory";
import {ruleList, RuleList} from "./rule-list/AlertDialogRuleListComponent";
import {alertDialog, AlertDialog} from "./dialog/AlertDialogComponent";
import {alertViewDialog, AlertViewDialog} from "./view-dialog/AlertDialogComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/alert-dialog`;

    return angular.module("tfApp.trading-alerts.alert-dialog", [Rules(rootDir)])
                  .component(AlertDialog, alertDialog(rootDir))
                  .component(AlertViewDialog, alertViewDialog(rootDir))
                  .component(RuleList, ruleList(rootDir))
                  .service(StoreFactory, alertDialogStoreFactory)
                  .name;
}
